import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'kebabCase',
    standalone: true, // remove this if not using standalone components
})
export class KebabCasePipe implements PipeTransform {
    transform(value: string): string {
        if (!value) return '';

        return value.trim().toLowerCase().replace(/\s+/g, '-'); // replace spaces with hyphens
    }
}
